// src/modules/auth/ui/RequestAnotherCode.tsx

/** @jsx createElement */
import { createElement } from "../../../utils/jsx.ts";

import { id } from "../../../utils/id.ts";
import { requestAnotherCode } from "../services/requestAnotherCode.ts";
import { NEW_CODE_TIMEOUT } from "../constants.ts";

interface Params {
  email: string;
}

export const RequestAnotherCode = ({ email }: Params) => {
  const buttonId = id();
  const button = (<button type="button" class="request-another-code" id={buttonId}></button>) as HTMLButtonElement;
  let secondsUntilActive: number;

  const updateButton = () => {
    if (secondsUntilActive > 0) {
      button.onclick = null;
      button.innerText = `Wyślij ponownie kod (dostępne za ${secondsUntilActive}s)`;
      button.disabled = true;
    } else {
      button.onclick = async () => {
        await requestAnotherCode({ email, buttonId: buttonId });
        secondsUntilActive = NEW_CODE_TIMEOUT;
        countdown();
      };
      button.innerText = "Wyślij ponownie kod";
      button.disabled = false;
    }
  };

  const countdown = () => {
    secondsUntilActive = NEW_CODE_TIMEOUT;
    updateButton();
    const interval = setInterval(() => {
      secondsUntilActive -= 1;
      updateButton();
      if (secondsUntilActive === 0) {
        clearInterval(interval);
      }
    }, 1000);
  };
  countdown();

  return button;
};
